{
  "alert": "Ειδοποίηση",
  "dismiss": "Απόρριψη"
}
